import Vue from 'vue';
import Router from 'vue-router';

import BaseMitUserModel from '../models/BaseMitUserModel.js';
import BaseMitUserService from '../services/BaseMitUserService.js';


import BaseMitLandingPage from '../pages/BaseMitLandingPage.vue';
import BaseMitNoAccessPage from '../pages/BaseMitNoAccessPage.vue';


Vue.use(Router);

const routerGuardAccessCheck = (to, from, next) => {

  BaseMitUserService.getUser()
    .then((user) => {
      if (user && user.role >= to.meta.allowedRole ) {
        //Add current user and role options to the page
        to.params.userModel = user;
        to.params.userRoles = BaseMitUserModel.ROLES;
        next();
      }
      else if (user && user.role < to.meta.allowedRole ) {
          //Just don't have access but the user is logged in
          next({ name: "no-access"});
      }
      else {
        //No user, probably not logged in
        //Redirect to OIDC login ideally but for now just push them back to the login page
        //TODO: FIGURE OUT HOW TO PASS a param to get back to where the user was originally going.
        //window.location.href = '/auth/provider';
        //I think I can do this with a temp session like I am doing for DUO that would survive the redirect.
        next({ name: "landing"});
      }
    })
    .catch((error) => {
      console.log('An error occurred trying to get signed in user', error);
      next({ name: "no-access"});
    });
}

import {getAppRoutes, defaultRoute} from '../../app/router';
let routes = [];

let baseRoutes = [
  {
    path: '/landing',
    name: 'landing',
    component: BaseMitLandingPage
  },
  {
    path: '/noaccess',
    name: 'no-access',
    component: BaseMitNoAccessPage,
  },
  {
    path: '*',
    //redirect: { name: 'landing' },
    beforeEnter(to, from, next) {
      BaseMitUserService.getUser()
        .then((user) => {
          //If the user is logged in go home
          if (user ) {
            //Add current user and role options to the page
            to.params.userModel = user;
            to.params.userRoles = BaseMitUserModel.ROLES;
            next({ name: defaultRoute})
          }
          //else send to landing page
          else {
            next({ name: "landing"});
          }
        })
        .catch((error) => {
          console.log('An error occurred trying to get signed in user', error);
          next({ name: "landing"});
        });
    }
  },
];

let appRoutes = getAppRoutes(BaseMitUserModel, routerGuardAccessCheck)

//Remove any duplicates in the baseRoutes before we merge routes.
//In case the app has overwritten a route, we should use that one instead.
for(let a = 0; a < appRoutes.length; a++){
  for(let b = 0; b < baseRoutes.length; b++){
    if(appRoutes[a].path === baseRoutes[b].path){
      baseRoutes.splice(b, 1);
      break;
    }
  }
}

routes = baseRoutes.concat(appRoutes);

export default new Router({
  routes,
  mode: 'history'
});
